'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.validYear = exports.validMonth = exports.validDay = exports.maxValidAge = exports.acceptedExpiryDate = exports.reasonableDateOfBirth = exports.validAge = void 0;
var date_1 = require("../helpers/date");
var helpers_1 = require("../helpers");
/**
 * Validates a minimum age for a date field.
 * @param legalAge the minimum legal age
 */
function validAge(legalAge) {
    return function (model) {
        var date = extractDate(model);
        if (!date) {
            return false;
        }
        var legalDate = new Date();
        legalDate.setFullYear(legalDate.getFullYear() - legalAge);
        return date.getTime() < legalDate.getTime();
    };
}
exports.validAge = validAge;
/**
 * We consider reasonable date of birth if:
 * 1. it's less than 100 years ago
 * 2. it's not in the future
 */
var reasonableDateOfBirth = function (model) {
    var date = extractDate(model);
    if (!date) {
        return false;
    }
    // 100 years ago date
    var pastLimitDate = new Date();
    pastLimitDate.setFullYear(pastLimitDate.getFullYear() - 100);
    return date > pastLimitDate && date < new Date();
};
exports.reasonableDateOfBirth = reasonableDateOfBirth;
/**
 * Accepted expiry date should be:
 * 1. Not in the past
 * 2. Has a maximum years limit
 */
var acceptedExpiryDate = function (props) {
    var model = props.model, _a = props.futureDateStart, futureDateStart = _a === void 0 ? new Date() : _a, futureYearLimit = props.futureYearLimit;
    var date = extractDate(model);
    if (!date) {
        return false;
    }
    var currentDate = new Date();
    var maxFutureYear = futureDateStart.getFullYear() + futureYearLimit;
    var maxExpiryDate = new Date(maxFutureYear, futureDateStart.getMonth(), futureDateStart.getDate());
    if (date > maxExpiryDate || date < currentDate || date < futureDateStart) {
        return false;
    }
    return true;
};
exports.acceptedExpiryDate = acceptedExpiryDate;
/**
 * Validates a maximum age for a date field.
 */
function maxValidAge(maxAge) {
    return function (model) {
        var date = extractDate(model);
        if (!date) {
            return false;
        }
        var legalDate = new Date();
        legalDate.setFullYear(legalDate.getFullYear() - maxAge);
        return date.getTime() > legalDate.getTime();
    };
}
exports.maxValidAge = maxValidAge;
/**
 * Extracts the full date from the date field
 * or false if not.
 * @param field The date field
 */
function extractDate(field) {
    var day = helpers_1.toNumber(field.day);
    var month = helpers_1.toNumber(field.month);
    var year = helpers_1.toNumber(field.year);
    if (!validDay(field.day, field) ||
        !validMonth(field.month) ||
        !validYear(field.year)) {
        return false;
    }
    return new Date(year, month - 1, day);
}
/**
 * Validates a day value.
 * @param value Value for the given day
 * @param field Object to check if valid for the given year/month
 */
function validDay(_, field) {
    var strDay = field.day, strMonth = field.month, strYear = field.year;
    var day = helpers_1.toNumber(strDay);
    var month = helpers_1.toNumber(strMonth);
    var year = helpers_1.toNumber(strYear);
    if (month && year && day && day > date_1.daysInMonth(month, year)) {
        return false;
    }
    return day !== null && day >= 1 && day <= 31;
}
exports.validDay = validDay;
/**
 * Validates the month value given is valid.
 * @param value value for the month
 */
function validMonth(value) {
    var month = helpers_1.toNumber(value);
    return month >= 1 && month <= 12;
}
exports.validMonth = validMonth;
/**
 * Validates the year is within reasonable bounds.
 * @param value value for the year
 */
function validYear(value) {
    var year = helpers_1.toNumber(value);
    return year >= 1890 && year <= 2099;
}
exports.validYear = validYear;
